// // =================

// import React, { useState, useEffect, useRef, useContext } from "react";
// import styles from "./dynamicSelect.module.css";
// // import { join } from "path"; // این خط معمولاً در کلاینت ریکت نیاز نیست، مگر اینکه بک‌اند خاصی باشد. اگر ارور داد حذفش کن.
// import { AdminContext } from "@/context/AdminContext";
// import GeneralIcons from "@/icons";
// import Loader from "../Loader";
// import Select from "../Select";

// const DynamicSelectSort = ({
//   classContainer,
//   options = [],
//   placeholder = "لطفاً انتخاب کنید",
//   title,
//   name,
//   // value,
//   onSelect,
//   errModal,
//   showError = false,
//   apiCall = null,
//   listTitleKey=[],
//   propsValue,
//   searchkey = "title",
//   apiParams = {},
//   getInitialList = true,
//   localSearch=false,
//   apiCategory=[{id:1, title:"h"}]
// }) => {

//   let value= propsValue ?  {...propsValue, dynamicSelectTitle:
//     listTitleKey
//     ?.map(m => propsValue?.[m])            // collect all desired fields
//     .filter(Boolean)              // remove empty or undefined ones
//     .join(" - ")               // join with a dash separator
//   } : null
//   const [isOpen, setIsOpen] = useState(false);
//   // const [searchTerm, setSearchTerm] = useState("");
//   const containerRef = useRef(null);
//   const [newSearch, setNewSearch] = useState(null);
//   const [listOptions, setListOptions] = useState(options?.map((x) => ({ ...x,
//     // dynamicSelectTitle:  listTitleKey?.map((m)=>(x?.[m]))
//     dynamicSelectTitle:  listTitleKey
//     ?.map(m => x?.[m])            // collect all desired fields
//     .filter(Boolean)              // remove empty or undefined ones
//     .join(" - ")               // join with a dash separator
//    })));
//   const [initialListOptions,setInitialListOptions]= useState(listOptions)

//   const debounceTimerRef = useRef(null);

//   const { setServerMessage } = useContext(AdminContext);
//   const [loading,setLoading]= useState(false)
//   const [activeApi,setActiveApi]= useState(apiCategory?.[0])

//   useEffect(() => {
//     if (getInitialList) {
//       apiFunction()
//     }
//   }, []);

//   useEffect(() => {
//     if (options?.length !== 0) {
//       let newarray=options?.map((x) => ({ ...x,
//         //  dynamicSelectTitle:
//         // listTitleKey?.map((m)=>(x?.[m]))
//         dynamicSelectTitle:  listTitleKey
//         ?.map(m => x?.[m])            // collect all desired fields
//         .filter(Boolean)              // remove empty or undefined ones
//         .join(" - ")               // join with a dash separator
//        }))
//       setListOptions(newarray)
//       setInitialListOptions(newarray)
//     }
//   }, [options]);

// console.log("listOptions========",listOptions)
//   useEffect(() => {
//     return () => {
//       if (debounceTimerRef.current) {
//         clearTimeout(debounceTimerRef.current);
//       }
//     };
//   }, []);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         containerRef.current &&
//         !containerRef.current.contains(event.target)
//       ) {
//         setIsOpen(false);
//         // console.log("hh====", newSearch , value?.title,)
//         if (newSearch?.length !=0 &&
//           listOptions?.length ==0
//           //  newSearch != value?.[listTitleKey]
//            ){
//           setNewSearch()
//           setListOptions(initialListOptions)
//         }
//         if (isOpen) {
//           if (value){
//           handleSelect({...value})
//           }else{
//             handleSelect({id:null, dynamicSelectTitle:  "",
//             //  [listTitleKey]: ""
//             })
//           }
//         }
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [value, isOpen, newSearch]);
//   console.log("initialListOptions====", initialListOptions)
//   const handleSelect = (newValue) => {
//     console.log("newValue==",newValue, listOptions)
//     setIsOpen(false);
//     setNewSearch(null)
//     onSelect?.(newValue);
//     // setSearchTerm(listOptions?.filter((x) => x.id == newValue?.id)?.map((x) => ({ ...x, dynamicSelectTitle:  x?.[`${listTitleKey}`] }))?.[0]?.title)
//   };
//   const apiFunction = (params = {}) => {
//     if (!apiCall) return;

//     apiCall({ params: { ...apiParams, ...params } })
//       .then((res) => {
//         setLoading(false)
//         let response = res?.data?.response?.map((x) => ({ ...x,
//           // dynamicSelectTitle:  listTitleKey?.map((m)=>(x?.[m]))
//           dynamicSelectTitle:  listTitleKey
//           ?.map(m => x?.[m])            // collect all desired fields
//           .filter(Boolean)              // remove empty or undefined ones
//           .join(" - ")               // join with a dash separator
//          }))
//         setListOptions(response)
//         if (Object.keys(params).length === 0){
//           setInitialListOptions(response)
//         }
//       })
//       .catch((err) => {
//         setLoading(false)
//         setServerMessage({
//           dynamicSelectTitle:  "Error",
//           text: err?.message + " , " + err?.response?.data?.message,
//         });
//       })
//   }

//   const handleInputChange = (e) => {
//     const seachvalue = e.target.value;
//     console.log("sssssss====", seachvalue)
//     setNewSearch(seachvalue);

//     if (apiCall && !localSearch) {
//       setLoading(true)
//       if (debounceTimerRef.current) {
//         clearTimeout(debounceTimerRef.current);
//       }

//       debounceTimerRef.current = setTimeout(() => {
//         const obj = {
//           [`${searchkey}`]: seachvalue?.trim()?.length != 0 && seachvalue ? seachvalue : undefined
//         };
//         apiFunction(obj);
//       }, 2000);

//     } else {
//       const filteredOptions = listOptions?.filter((option) =>
//         (option.dynamicSelectTitle)
//           .toLowerCase()
//           .includes(seachvalue.toLowerCase())
//       );
//       // const filteredOptions = listOptions?.filter(option =>
//       //   listTitleKey.some(key =>
//       //     String(option[key] ?? "").toLowerCase().includes(seachvalue.toLowerCase())
//       //   )
//       // );
//       console.log("filteredOptions==",filteredOptions, listOptions)
//       setListOptions(filteredOptions)
//     }
//   }

//   const handleKeyDown= (e) => {
//     if (e.key === "Backspace") {
//       setNewSearch("")
//       setListOptions(initialListOptions)
//     }
//     if (e.key === "Enter") {
//       const value = e.target.value;
//       setNewSearch(value);
//       // if (apiCall && newSearch) {
//       //    if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
//       //    const obj = { [`${searchkey}`]: newSearch?.trim() };
//       //    apiFunction(obj);
//       // }
//     }
//   };
// console.log("newSearch==", newSearch, value?.dynamicSelectTitle, listTitleKey?.map((x)=>(value?.[x])) )
// console.log("value====is", value?.dynamicSelectTitle, listTitleKey?.map((x)=>(value?.[x])))
//   return (
//     <>
//       <div
//         ref={containerRef}
//         className={`${errModal ? styles.errorBorder : " "} ${classContainer} ${styles.container
//           } ${(value == null || value == "") && showError && styles.error}`}
//       >
//         {(title || name) && <p className={styles.title}>{title || name}</p>}

//         <div className={`${styles.selectBox} ${isOpen ? styles.open : ""} `}>
//           <>

//             <input
//               type="text"
//               className={`${styles.searchInput}`}
//               placeholder={placeholder}
//               // value={newSearch != null ? newSearch :
//               //   value ?  `${listTitleKey?.length !=0 ? listTitleKey?.map((x)=>(value?.[x])) : "" }`
//               // : null}
//               value={newSearch != null ? newSearch :
//                 value ?  `${value?.dynamicSelectTitle} `
//               : null}
//               onClick={() => setIsOpen(true)}
//               onChange={handleInputChange}
//               onKeyDown={handleKeyDown}
//             />
//             <div className={`${styles.iconContainer}`}>

//             {(value?.id || newSearch) &&
//             <GeneralIcons.closeIcon className={`${styles.closeIcon}`} fill="#67687A" onClick={() => handleSelect({id:null, dynamicSelectTitle:  ""
//             // , [listTitleKey]: ""
//             })} width="12px" height="12px"/>
//             }
//             {apiCategory?.length !=0 &&
//             <Select value={activeApi?.id} placeholder={activeApi?.title} list={apiCategory}/>
//             }
//             <img
//               src="/imgs/sidebar/arrow.svg"
//               alt="arrow"
//               onClick={() => setIsOpen(!isOpen)}
//               className={`${isOpen ? styles.rotate : ""}`}
//             />
//             </div>
//           </>
//         </div>

//         {isOpen && (
//           <div className={styles.options}>
//             {!loading ?
//             <>
//             {listOptions?.length!=0 ?
//               <>
//               {listOptions?.map((option) => (
//                 <p
//                   key={option.id}
//                   className={`${styles.option} ${value?.id === option.id ? styles.activeOption : ""
//                     }`}
//                   onClick={() => handleSelect(option)}
//                 >
//                   {/* {`${option?.[listTitleKey]} ${listTitleKey?.length !=0 ? listTitleKey?.map((x)=>{return option?.[x]}) : ""}`} */}
//                   {option?.dynamicSelectTitle}
//                 </p>
//               ))}
//               </>
//             :
//               <p className={`${styles.option}`}>موردی یافت نشد.</p>
//             }
//             </>
//             :
//             <Loader className={`${styles.loader}`}/>
//             }

//           </div>
//         )}
//       </div>
//       {(value?.id == null || value?.id == "") && showError &&
//         <p className={`${"inputError"}`}>مقدار ضروری است.</p>
//       }
//     </>
//   );
// };

// export default DynamicSelectSort;

// ====================

// =================

import React, { useState, useEffect, useRef, useContext, useMemo } from 'react';
import styles from './dynamicSelect.module.css';
import Loader from '../Loader';
import Select from '../Select';
import { useLayoutContext } from '@/context/LayoutContext';
import MainIcons from '@/icons/main';
import { useTranslations } from 'next-intl';
import ToolbarIcons from '@/icons/toolbar';

const DynamicSelectSort = ({
  classContainer = '',
  // options = [],
  item,
  // placeholder = "لطفاً انتخاب کنید",
  // title,
  // name,
  // value,
  onSelect = () => {},
  errModal = null,
  showError = false,
  // apiCall = null,
  // listTitleKey=[],
  propsValue = '',
  // searchkey = "title",
  // apiParams = {},
  // getInitialList = true,
  // localSearch=false,
  apiCategory = [],
  disabled = false,
  extraInfo = '',
  searchValue = null,
  id,
  placeholder,
  showSelect,
}) => {
  const apiCategorySignature = useMemo(() => {
    return JSON.stringify(apiCategory ?? []);
  }, [apiCategory]);
  const [activeCategory, setActiveCategory] = useState(apiCategory?.[0]);
  const [isOpen, setIsOpen] = useState(false);
  // const [searchTerm, setSearchTerm] = useState("");
  const containerRef = useRef(null);
  const [newSearch, setNewSearch] = useState(searchValue);

  useEffect(() => {
    if (searchValue) {
      setNewSearch(searchValue);
    }
  }, [searchValue]);
  const [listOptions, setListOptions] = useState(
    activeCategory?.options?.map((x) => ({
      ...x,
      // dynamicSelectTitle:  listTitleKey?.map((m)=>(x?.[m]))
      dynamicSelectTitle: activeCategory?.listTitleKey
        ?.map((m) => x?.[m]) // collect all desired fields
        .filter(Boolean) // remove empty or undefined ones
        .join(' - '), // join with a dash separator
    })),
  );
  let value = propsValue?.id
    ? {
        ...propsValue,
        // Merge extra dynamic info from activeCategory.extraListInfo
        ...(activeCategory?.extraListInfo
          ? activeCategory.extraListInfo.reduce((acc, m) => {
              acc[m.title] = typeof m.value === 'function' ? m.value(propsValue) : m.value;
              return acc;
            }, {})
          : {}),
      }
    : propsValue;

  console.log('vvvvvvvvvvvvvvv', value, propsValue);

  value = value
    ? {
        ...value,

        dynamicSelectTitle: activeCategory?.listTitleKey
          ?.map((m) => value?.[m]) // collect all desired fields
          .filter(Boolean) // remove empty or undefined ones
          .join(' - '), // join with a dash separator
      }
    : null;

  const [initialListOptions, setInitialListOptions] = useState(listOptions);
  const tCommon = useTranslations('common');

  console.log('listOptions========', listOptions);
  const debounceTimerRef = useRef(null);

  const { setServerMessage } = useLayoutContext();
  const [loading, setLoading] = useState(false);

  // useEffect(()=>{
  //   setActiveCategory(activeCat)
  // },[activeCat])
  // useEffect(() => {
  //   if (apiCategory && !activeCategory){
  //   setActiveCategory(item?.apiCategory?.[0])
  //   }
  // }, [item]);

  useEffect(() => {
    let index = apiCategory?.findIndex((x) => x.id == activeCategory?.id);
    // if (apiCategory?.[index]?.options && apiCategory?.[index]?.options?.length !=0
    //     ){
    setActiveCategory(apiCategory?.[index]);

    // }
  }, [apiCategorySignature]);

  console.log('apiCategory==', apiCategory);

  const changeOptionlist = (activeCategory) => {
    let newarray = activeCategory?.options
      ? activeCategory?.options?.map((x) => ({
          ...x,

          // Merge extra dynamic info from activeCategory.extraListInfo
          ...(activeCategory?.extraListInfo
            ? activeCategory.extraListInfo.reduce((acc, m) => {
                acc[m.title] = typeof m.value === 'function' ? m.value(x) : m.value;
                return acc;
              }, {})
            : {}),
        }))
      : [];
    newarray = activeCategory?.options
      ? newarray?.map((x) => ({
          ...x,
          //  dynamicSelectTitle:
          // listTitleKey?.map((m)=>(x?.[m]))
          dynamicSelectTitle: activeCategory?.listTitleKey
            ?.map((m) => x?.[m]) // collect all desired fields
            .filter(Boolean) // remove empty or undefined ones
            .join(' - '), // join with a dash separator
        }))
      : [];
    setListOptions(newarray);
    setInitialListOptions(newarray);
  };
  console.log('item==', item);
  useEffect(() => {
    if (!activeCategory?.options) {
      // if (activeCategory?.getInitialList) {
      apiFunction({}, activeCategory);
    } else {
      changeOptionlist(activeCategory);
    }
  }, [activeCategory]);

  // useEffect(() => {
  //   // if (activeCategory?.options?.length !== 0) {
  //     let newarray= activeCategory?.options ? activeCategory?.options?.map((x) => ({ ...x,
  //       //  dynamicSelectTitle:
  //       // listTitleKey?.map((m)=>(x?.[m]))
  //       dynamicSelectTitle:  activeCategory?.listTitleKey
  //       ?.map(m => x?.[m])            // collect all desired fields
  //       .filter(Boolean)              // remove empty or undefined ones
  //       .join(" - ")               // join with a dash separator
  //      })) : []
  //     setListOptions(newarray)
  //     setInitialListOptions(newarray)
  //   // }
  // }, [activeCategory,]);

  console.log('listOptions========', listOptions);
  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
        // console.log("hh====", newSearch , value?.title,)
        if (
          (newSearch?.length != 0 && listOptions?.length == 0) ||
          !value?.id
          //  newSearch != value?.[listTitleKey]
        ) {
          setNewSearch();
          setListOptions(initialListOptions);
        }
        if (isOpen) {
          if (value) {
            handleSelect({ ...value });
          } else {
            handleSelect({
              id: null,
              dynamicSelectTitle: '',
              //  [listTitleKey]: ""
            });
          }
        } else {
          setListOptions(initialListOptions);
          // if (!value){
          //   handleSelect({id:null, dynamicSelectTitle:  "",})
          // }
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [value, isOpen, newSearch, initialListOptions]);

  useEffect(() => {
    if (!value) {
      handleSelect({ ...value });
    }
  }, [initialListOptions]);

  const checkKeys = (newValue) => {
    const newObj = {};

    // First, let's ensure all objects in apicategory have the 'key' property
    const allHaveKey = apiCategory.every((item) => {
      return item.hasOwnProperty('key');
    });

    if (allHaveKey) {
      apiCategory.forEach((item) => {
        newObj[item.key] = null;
        console.log('key==', item?.key, activeCategory);
        if (item?.key == activeCategory?.key) {
          newObj[item.key] = newValue;
        }
      });

      // activeCategory?.key= newValue
      // console.log(newObj); // Output: { '1': null, '2': null }
      return newObj;
    } else {
      return newValue;
    }
  };
  console.log('initialListOptions====', initialListOptions, listOptions);
  const handleSelect = (newValue) => {
    console.log('newValue==', newValue, listOptions);
    setIsOpen(false);
    setNewSearch(null);
    let returnedValue = checkKeys(newValue);
    console.log('returnedValue======', returnedValue);
    onSelect?.(returnedValue);
    setListOptions(initialListOptions);
    // setSearchTerm(listOptions?.filter((x) => x.id == newValue?.id)?.map((x) => ({ ...x, dynamicSelectTitle:  x?.[`${listTitleKey}`] }))?.[0]?.title)
  };
  // const apiFunction = (params = {}, activeCategory) => {
  //   if (!activeCategory?.apiCall) return;

  //   activeCategory?.apiCall({ params: { ...activeCategory?.apiParams, ...params } })
  //     .then((res) => {
  //       setLoading(false)
  //       let response = res?.data?.response?.map((x) => ({ ...x,
  //         dynamicSelectTitle:  activeCategory?.listTitleKey
  //         ?.map(m => x?.[m])            // collect all desired fields
  //         .filter(Boolean)              // remove empty or undefined ones
  //         .join(" - ")               // join with a dash separator
  //        }))
  //       setListOptions(response)
  //       if (Object.keys(params).length === 0){
  //         setInitialListOptions(response)
  //       }
  //     })
  //     .catch((err) => {
  //       setLoading(false)
  //       setServerMessage({
  //         dynamicSelectTitle:  "Error",
  //         text: err?.message + " , " + err?.response?.data?.message,
  //       });
  //     })
  // }
  const apiFunction = (params = {}, activeCategory) => {
    if (!activeCategory?.apiCall) return;

    setLoading(true);

    activeCategory
      .apiCall({
        params: { ...activeCategory.apiParams, ...params },
      })
      .then((res) => {
        setLoading(false);

        let response =
          res?.data?.response?.map((x) => ({
            ...x,

            // Merge extra dynamic info from activeCategory.extraListInfo
            ...(activeCategory?.extraListInfo
              ? activeCategory.extraListInfo.reduce((acc, m) => {
                  acc[m.title] = typeof m.value === 'function' ? m.value(x) : m.value;
                  return acc;
                }, {})
              : {}),
          })) || [];

        response =
          response?.map((x) => ({
            ...x,

            // Construct title from multiple fields
            dynamicSelectTitle: activeCategory?.listTitleKey
              ?.map((m) => x?.[m])
              .filter(Boolean)
              .join(' - '),
          })) || [];

        setListOptions(response);

        console.log('ressssssssssssssss', response);
        // Only called if params are empty
        if (Object.keys(params).length === 0) {
          // alert("1")
          setInitialListOptions(response);
          // if (!value){

          // }
        }
      })
      .catch((err) => {
        setLoading(false);
        // setServerMessage({
        //   dynamicSelectTitle: 'Error',
        //   text: `${err?.message || ''} , ${err?.response?.data?.message || ''}`,
        // });
      });
  };

  console.log('activeCategory========', activeCategory);
  const handleInputChange = (e) => {
    const seachvalue = e.target.value;
    console.log('sssssss====', seachvalue);
    setNewSearch(seachvalue);

    if (
      activeCategory?.apiCall
      // && !activeCategory?.localSearch
    ) {
      setLoading(true);
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }

      debounceTimerRef.current = setTimeout(() => {
        const obj = {
          [`${activeCategory?.searchkey}`]:
            seachvalue?.trim()?.length != 0 && seachvalue ? seachvalue?.trim() : undefined,
        };
        apiFunction(obj, activeCategory);
      }, 2000);
    } else {
      const filteredOptions = listOptions?.filter((option) =>
        option.dynamicSelectTitle.toLowerCase().includes(seachvalue.toLowerCase()?.trim()),
      );
      // const filteredOptions = listOptions?.filter(option =>
      //   listTitleKey.some(key =>
      //     String(option[key] ?? "").toLowerCase().includes(seachvalue.toLowerCase())
      //   )
      // );
      console.log('filteredOptions==', filteredOptions, listOptions);
      setListOptions(filteredOptions);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Backspace') {
      setNewSearch('');
      setListOptions(initialListOptions);
    }
    if (e.key === 'Enter') {
      const value = e.target.value;
      setNewSearch(value);
      // if (apiCall && newSearch) {
      //    if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
      //    const obj = { [`${searchkey}`]: newSearch?.trim() };
      //    apiFunction(obj);
      // }
    }
  };
  // const closeIconFunction=()=>{
  //   handleSelect({id:null, dynamicSelectTitle:  "",

  //           // , [listTitleKey]: ""
  //           })
  // }
  const closeIconFunction = () => {
    // Assuming 'items' is accessible here and contains the relevant data
    // For example, if 'items' is { title: "Some Title", id: 1, ... }

    let selectPayload = {
      id: null,
      dynamicSelectTitle: '',
    };

    // Dynamically add properties to selectPayload based on activeCategory?.listTitleKey
    if (activeCategory?.listTitleKey && Array.isArray(activeCategory.listTitleKey)) {
      activeCategory.listTitleKey
        ?.filter((m) => m != 'id')
        .forEach((key) => {
          selectPayload = { ...selectPayload, [`${key}`]: '' }; // Or null, or undefined, depending on desired behavior
        });
    }
    setListOptions(initialListOptions);

    handleSelect(selectPayload);
  };

  console.log(
    'newSearch==',
    newSearch,
    value?.dynamicSelectTitle,
    activeCategory?.listTitleKey?.map((x) => value?.[x]),
  );
  console.log('value====is', value, newSearch, value?.dynamicSelectTitle, value?.id);
  return (
    <div className={`${item.classMain} ${styles.selectWrapper}`}>
      {activeCategory?.title && (
        <div className={`formTitle`}>
          <p className={`${item?.classTitle} ${styles.title}`}>
            {activeCategory?.title}
            {extraInfo && <span className={item?.styleColor}>{extraInfo}</span>}
          </p>
        </div>
      )}
      <div
        ref={containerRef}
        className={`${errModal ? styles.errorBorder : ' '} ${classContainer} ${
          styles.container
        } ${value?.id == null && showError && styles.error} inputPart withinFocus  lightInput ${disabled && 'disabled'}`}
      >
        {/* {(activeCategory?.title) && <p className={styles.title}>{activeCategory?.title}</p>} */}

        <div className={`${styles.selectBox} ${isOpen && !disabled ? styles.open : ''} `}>
          <>
            <input
              type="text"
              className={`${styles.searchInput}`}
              placeholder={activeCategory?.placeholder}
              // value={newSearch != null ? newSearch :
              //   value ?  `${listTitleKey?.length !=0 ? listTitleKey?.map((x)=>(value?.[x])) : "" }`
              // : null}
              value={newSearch != null ? newSearch : value ? value?.dynamicSelectTitle : null}
              onClick={() => !disabled && setIsOpen(true)}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              disabled={disabled}
            />
            <div className={`${styles.iconContainer}`}>
              {(value?.id || newSearch) && (
                <ToolbarIcons.CloseCircleIcon
                  className={`${styles.closeIcon} ${apiCategory?.length <= 1 && styles.noSelectCategoryStyle}`}
                  fill={'var(--paper)'}
                  onClick={closeIconFunction}
                  width="16px"
                  height="16px"
                />
              )}
              {apiCategory?.length > 1 && (
                <Select
                  value={activeCategory?.id}
                  placeholder={activeCategory?.title}
                  list={apiCategory}
                  fillFormFunction={(id) => {
                    let newActive = apiCategory?.filter((x) => x.id == id)?.[0];
                    if (activeCategory?.id != newActive?.id) {
                      setActiveCategory(newActive);
                      closeIconFunction();
                      // if (newActive?.getInitialList){
                      if (newActive?.apiCall) {
                        setLoading(true);
                        // apiFunction({},newActive)
                      } else {
                        changeOptionlist(newActive);
                      }
                    }
                  }}
                  ulClassName={styles.categoryList}
                  className={`${styles.categoryClassName}`}
                />
              )}
              {/* <img
              src="/imgs/sidebar/arrow.svg"
              alt="arrow"
              width={10}
              height={10}
              onClick={() => setIsOpen(!isOpen)}
              className={`${isOpen ? styles.rotate : ""}`}
            /> */}
              <MainIcons.arrowIcon
                width={'14px'}
                height={'14px'}
                className={`${styles.arrowIcon} ${isOpen && styles.arrowIconOpen} arrowIcon`}
                onClick={() => setIsOpen(!isOpen)}
              />
            </div>
          </>
        </div>

        {isOpen && (
          <div className={`  ${styles.options} ${listOptions?.length == 0 && styles.empty}`}>
            {!loading ? (
              <>
                {listOptions && listOptions?.length != 0 ? (
                  <>
                    {listOptions?.map((option) => (
                      <p
                        key={option.id}
                        className={`${styles.option} ${
                          value?.id === option.id ? styles.activeOption : ''
                        }`}
                        onClick={() => handleSelect(option)}
                      >
                        {/* {`${option?.[listTitleKey]} ${listTitleKey?.length !=0 ? listTitleKey?.map((x)=>{return option?.[x]}) : ""}`} */}
                        {option?.dynamicSelectTitle}
                      </p>
                    ))}
                  </>
                ) : (
                  <p className={`${styles.option} ${styles.empty}`}>{tCommon('emptyList')}</p>
                )}
              </>
            ) : (
              <Loader
                className={`${styles.loader}`}
                containerclassname={`${styles.loaderContainer}`}
              />
            )}
          </div>
        )}
      </div>
      {/* {(value?.id == null || value?.id == "") && showError &&
        <p className={`${"inputError"}`}>مقدار ضروری است.</p>
      } */}
      {item?.showError && <p className={`inputError`}>{item?.error}</p>}
    </div>
  );
};

export default DynamicSelectSort;
